import React, { useState, useEffect, useRef } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, GridColumnMenu, useGridApiRef, GridFooter, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal } from '../../contexts';
import AddEvent from '../../components/Modals/AddEvent';
import SendTxt from '../../components/Modals/SendTxt';
import SendEmail from '../../components/Modals/SendEmail';
import LogComms from '../../components/Modals/LogComms';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import TaskStatusChange from '../../components/Modals/TaskStatusChange';
import TaskReassign from '../../components/Modals/TaskReassign';
import NamesInGrid from './NamesInGrid';
import { formatPhone, launchPhoneBurner, singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import Select from 'react-select';
import NoteInGrid from '../Contacts/NoteInGrid';
import TaskInGrid from '../Contacts/TaskInGrid';



import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const toolbar = ( { selectedRows, handleMassModal, hasTxting, hasPhoneBurner, canExport, timing, setTiming, type, setType, status, setStatus, assignedTo, setAssignedTo, team, viewing } ) => {
    const timingOptions = [
        { value: 'now', label: 'Due Now' },
        { value: 'today', label: 'Today Only' },
        { value: 'week', label: 'This Week' },
        { value: 'nextWeek', label: 'Next Week' },
        { value: 'month', label: 'This Month' },
        { value: 'nextMonth', label: 'Next Month' }
    ];
    const typeOptions = [
        { value: 'all', label: 'All Types' },
        { value: 'Call', label: 'Calls' },
        { value: 'Txt', label: 'Txt Msgs' },
        { value: 'Email', label: 'Emails' },
        { value: 'Video', label: 'Videos' },
        { value: 'Meeting', label: 'Meetings' },
        { value: 'To-Do', label: 'To-Dos' },
        { value: 'Send Card', label: 'Send Cards' },
        { value: 'Task', label: 'Tasks' },
        { value: 'Other', label: 'Other' }
    ];
    const statusOptions = [
        { value: 'Open', label: 'Open' },
        { value: 'Completed', label: 'Completed' },
        { value: 'Cancelled', label: 'Cancelled' },
        { value: 'Not Doing', label: 'Not Doing' }
    ];
    const userOptions = [];
    team.forEach( f => userOptions.push( { value: f.uid, label: f.name } ) );
    

    const changeTiming = ( t ) => {
        setTiming( t.value );
    }

    const changeType = ( t ) => {
        const list = [];
        if ( t.length && t[t.length - 1].value === 'all' ) {
            list.push( 'all' );
        } else {
            t.forEach( ( f, idx ) => {
                if ( t.length > 1 && f.value === 'all' ) {
                    return;
                }
                list.push( f.value ) 
            } );
        }
        
        if ( !list.length ) {
            list.push( 'all' );
        }
        
        setType( list );
    }

    const changeStatus = ( t ) => {
        const list = [];
        t.forEach( f => list.push( f.value ) );
        
        if ( !list.length ) {
            list.push( 'Open' );
        }
        
        setStatus( list );
    }
    
    const changeUser = ( t ) => {
        setAssignedTo( t.value );
    }

    return(
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col xs='auto'>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'change-status' ) }>Change Status</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'reassign' ) }>Reassign</Dropdown.Item>
                                                {/* <Dropdown.Divider /> */}
                                                {/* <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) } disabled={viewing.length !== 1}>Send Mass Email</Dropdown.Item> */}
                                                {
                                                    // hasTxting ? (
                                                    //     <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) } disabled={viewing.length !== 1}>Send Mass Txt</Dropdown.Item>
                                                    // ) : (
                                                    //     null
                                                    // )
                                                }
                                                {/* <Dropdown.Divider />
                                                <Dropdown.Item onClick={ () => handleMassModal( 'list' ) }>Add to a List</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'event' ) }>Add to an Event</Dropdown.Item> */}
                                                {
                                                    // hasPhoneBurner ? (
                                                    //     <>
                                                    //         <Dropdown.Divider />
                                                    //         <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                    //     </>
                                                    // ) : (
                                                    //     null
                                                    // )
                                                }
                                                
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                            <Col xs='auto'>
                                <Select id='taskTimeframe' isSearchable={true} classNamePrefix='tf-multiselect' value={timingOptions.find( f => f.value === timing )} options={timingOptions} onChange={changeTiming} />
                            </Col>
                            <Col xs='auto'>
                                <Select id='taskUser' isSearchable={true} classNamePrefix='tf-multiselect' value={userOptions.find( f => f.value === assignedTo )} options={userOptions} onChange={changeUser} />
                            </Col>
                            <Col xs='auto'>
                                <Select id='taskType' isSearchable={true} isClearable={false} isMulti={true} classNamePrefix='tf-multiselect' value={typeOptions.filter( f => type.includes( f.value ) )} options={typeOptions} onChange={changeType} />
                            </Col>
                            <Col xs='auto'>
                                <Select id='taskStatus' isSearchable={true} isClearable={false} isMulti={true} classNamePrefix='tf-multiselect' value={statusOptions.filter( f => status.includes( f.value ) )} options={statusOptions} onChange={changeStatus} />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const Tasks = ( { orgId, aid, uid, user, viewing, grids, canExport, stack, tasks, contacts, notes, conPicklist, oppPicklist, globalPicklist, setDatagridOrder, setDatagridWidth } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ tList, setTasks ] = useState( [] );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ hasUnsavedRows, setHasUnsavedRows ] = useState( false );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ singleSaveId, setSingleSaveId ] = useState( '' );
    const [ isDiscarding, setIsDiscarding ] = useState( false );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );

    const [ timing, setTiming ] = useState( 'now' );
    const [ type, setType ] = useState( [ 'all' ] );
    const [ status, setStatus ] = useState( [ 'Open' ] );
    const [ assignedTo, setAssignedTo ] = useState( uid );

    const containerRef = useRef();
    const titleRef = useRef();
    const modesRef = useRef();
    modesRef.current = rowModesModel;

    const gridRef = useGridApiRef();

    const location = useLocation();

    const query = useQuery();
    
    const formatName = ( cid ) => {
        const r = contacts[cid];
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    }

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'tasks';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'tasks';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const gridHelpers = {
        valueGetter: {
            contact: ( { row } ) => {
                let v = [];
                if ( row.assoc && row.assoc.length ) {
                    row.assoc.forEach( b => {
                        if ( b ) {
                            const c = contacts[b.cid];
                            if ( c ) { v.push( c.name ); }
                        }
                    } );
                }
                return v.join( ', ' );
            },
            phone: ( { row } ) => {
                let p; 
                if ( !row.assoc || !row.assoc.length ) {
                    return null;
                }
                row.assoc.forEach( ( b, idx ) => {
                    if ( b && idx === 0 ) {
                        const c = contacts[b.cid];
                        if ( c ) { 
                            if ( c.phoneMobile && c.phoneMobile.length ) {
                                p = c.phoneMobile;
                            } else if ( c.phone && c.phone.length ) {
                                p = c.phone;
                            }
                        }
                    }
                } );
                return ( p ) ? formatPhone( p ) : null;
            },
            email: ( { row } ) => {
                let e;
                if ( !row.assoc || !row.assoc.length ) {
                    return null;
                }
                row.assoc.forEach( ( b, idx ) => {
                    if ( b && idx === 0 ) {
                        const c = contacts[b.cid];
                        if ( c ) { e = c.email; }
                    }
                } );
                return ( e ) ? e : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    if ( !value.match( 'T' ) ) {
                        d.setDate( d.getDate() + 1 );
                    }
                }
                return ( d ) ? d : null;
            },
            latestClosedTask: ( { row } ) => {
                return row.lastTask;
            },
            latestNote: ( { row } ) => {
                return row.lastNote;
            }
        },
        renderCell: {
            subject: ( { row } ) => {
                return ( row.name ) ? <Link to={`/task/${row.tid}`}>{row.name}</Link> : null
            },
            phone: ( { row } ) => {
                let p = '';
                row.assoc.forEach( ( b, idx ) => {
                    if ( b && idx === 0 ) {
                        const c = contacts[b.cid];
                        if ( c ) { 
                            if ( c.phoneMobile && c.phoneMobile.length ) {
                                p = c.phoneMobile;
                            } else if ( c.phone && c.phone.length ) {
                                p = c.phone;
                            }
                        }
                    }
                } );
                return ( p.length ) ? <a href={`tel:${p}`}>{p}</a> : null;
            },
            email: ( { row } ) => {
                let e = '';
                if ( !row.assoc ) {
                    console.log( 'missing assocs: ', row );
                    return;
                }
                row.assoc.forEach( ( b, idx ) => {
                    if ( b && idx === 0 ) {
                        const c = contacts[b.cid]; // cl.find( f => f.cid === b.cid );
                        if ( c ) { e = c.email ? c.email : ''; }
                    }
                } );
                return ( e.length ) ? <a href={`mailto:${e}`}>{e}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { row } ) => {
                return <NamesInGrid row={row} />;
            },
            latestClosedTask: ( { value } ) => {
                return <TaskInGrid task={value} />;
            },
            latestNote: ( { value } ) => {
                return <NoteInGrid note={value} />;
            },
            html: ( { value } ) => {
                const clean = value ? value.replace( /\n/g, '<br />' ) : null;
                // return ( clean ) ? <div dangerouslySetInnerHTML={ { __html: value } } style={{ display: 'flex' }} /> : null;
                return ( clean ) ? <Box
                    component="div"
                    // all the wrapping rules live here
                    sx={{
                    whiteSpace: 'normal',            // allow wrapping
                    overflowWrap: 'anywhere',        // break long words / URLs
                    lineHeight: 1.4,
                    display: 'block',                // don’t use flex; it resists wrapping
                    }}
                    // still render the HTML note body
                    dangerouslySetInnerHTML={{ __html: value }}
                /> : null;
            }
        },
        valueFormatter: {
            subject: ( { value } ) => {
                return ( value ) ? value : null;
            },
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                return ( value ) ? value : null;
            },
            latestClosedTask: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            },
            latestNote: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleSingleModal = ( t, cid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'log-call':
                console.log( 'log-call w/ cid: ' + cid );
                setModal( <LogComms commType='Call' close={closeModal} cid={cid} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + cid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = async ( t ) => {
        let shouldOpen = true;

        const cons = [];
        const cids = [];
        const list = [];
        selectedRows.forEach( r => {
            console.log( r );
            const t = tasks[r];
            list.push( { aid: t.aid, tid: t.tid } );
            if ( t && t.assoc && t.assoc.length ) {
                const c = contacts[t.assoc[0].cid];
                if ( c ) {
                    cids.push( c.cid );
                    cons.push( c );
                } else {
                    console.log( 'unknown contact for: ', t.assoc );
                }
            }
        } );

        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail contacts={ contacts } close={ closeModal } aid={t.aid} /> ); 
                break;

            case 'sms-mass':
                setModal( <SendTxt contacts={ contacts } close={ closeModal } aid={t.aid} /> ); 
                break;
    
            case 'phoneburner':
                await launchPhoneBurner( t.aid, uid, cids, cons, stack.dialer );
                shouldOpen = false;
                break;
        
            case 'change-status':
                console.log( 'launching status change with: ', list );
                setModal( <TaskStatusChange close={ closeModal } tids={list} /> );
                break;

            case 'reassign':
                console.log( 'launching reassign with: ', list );
                setModal( <TaskReassign close={ closeModal } tids={list} /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'email':
                setModal( <SendEmail /> );
                break;

            case 'sms':
                setModal( <SendTxt /> );
                break;

            case 'event':
                setModal( <AddEvent /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
        
        console.log( 'modal: ' + t );
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    const isToday = ( dateString ) => {
        const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
        const today = new Date();
        
        const isSameYear = givenDate.getFullYear() === today.getFullYear();
        const isSameMonth = givenDate.getMonth() === today.getMonth();
        const isSameDay = givenDate.getDate() === today.getDate();
        
        return isSameYear && isSameMonth && isSameDay;
    }

    const isThisWeek = ( dateString ) => {
        const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
        const today = new Date();
      
        const startOfWeek = new Date( today.setDate( today.getDate() - today.getDay() ) );
      
        const endOfWeek = new Date( startOfWeek );
        endOfWeek.setDate( startOfWeek.getDate() + 6 );
      
        startOfWeek.setHours( 0, 0, 0, 0 );
        endOfWeek.setHours( 23, 59, 59, 999 );
        givenDate.setHours( 0, 0, 0, 0 );
      
        return ( givenDate >= startOfWeek && givenDate <= endOfWeek );
    }

    const isNextWeek = ( dateString ) => {
        const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
        const today = new Date();
      
        const currentWeekStart = new Date( today.setDate( today.getDate() - today.getDay() ) );
      
        const nextWeekStart = new Date( currentWeekStart );
        nextWeekStart.setDate( currentWeekStart.getDate() + 7 );
      
        const nextWeekEnd = new Date( nextWeekStart );
        nextWeekEnd.setDate( nextWeekStart.getDate() + 6 );
      
        nextWeekStart.setHours( 0, 0, 0, 0 );
        nextWeekEnd.setHours( 23, 59, 59, 999 );
        givenDate.setHours( 0, 0, 0, 0 );
      
        return ( givenDate >= nextWeekStart && givenDate <= nextWeekEnd );
    }

    const isThisMonth = ( dateString ) => {
        const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
        const today = new Date();
      
        const isSameYear = givenDate.getFullYear() === today.getFullYear();
        const isSameMonth = givenDate.getMonth() === today.getMonth();
      
        return isSameYear && isSameMonth;
    }

    const isNextMonth = ( dateString ) => {
        const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
        const today = new Date();
      
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();
      
        const nextMonth = ( currentMonth + 1 ) % 12;
        const nextMonthYear = ( currentMonth === 11 ) ? currentYear + 1 : currentYear;
      
        // Check if the given date's month and year match the next month's
        const isSameYear = givenDate.getFullYear() === nextMonthYear;
        const isSameMonth = givenDate.getMonth() === nextMonth;
      
        return ( isSameYear && isSameMonth );
    }

    const isInPast = ( dateString ) => {
        const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
        const today = new Date();
      
        today.setHours(0, 0, 0, 0);
        givenDate.setHours(0, 0, 0, 0);
      
        return givenDate < today;
    }

    useEffect( () => {
        document.title = 'Third Floor - Tasks';
    }, [] );
    
    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.tasks && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );
            
            let storedCols = JSON.parse( grids.tasks.cols );
            if ( filters.fn && grids.tasks.filters && grids.tasks.filters[filters.fn] ) {
                if ( grids.tasks.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.tasks.filters[filters.fn].cols );
                }

                if ( grids.tasks.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.tasks.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.tasks.filters[filters.fn].className ) {
                    setClassLogic( grids.tasks.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.tasks.className ) {
                    setClassLogic( grids.tasks.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }

                    if ( user && user.datagrids && user.datagrids.tasks ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.tasks.filters && user.datagrids.tasks.filters[filters.fn] && user.datagrids.tasks.filters[filters.fn].colSize && user.datagrids.tasks.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.tasks.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.tasks.colSize && user.datagrids.tasks.colSize[c.field] ) {
                            c.width = user.datagrids.tasks.colSize[c.field];
                        }
                    }

                    if ( c.type === 'singleSelect' ) {
                        let list = [];
                        switch ( c.sso ) {
                            case 'global':
                                list = globalPicklist[c.field];
                                break;

                            case 'contact':
                                list = conPicklist[c.field];
                                break;

                            case 'leadopp':
                                list = oppPicklist[c.field];
                                break;

                            default:
                                console.log( 'unknown/missing column object for singleSelect: ' + c.obj );
                        }
                        c.valueOptions = ( list ) ? list.map( m => {
                            return { value: m.value, label: m.label };
                        } ) : [];

                        if ( c.valueOptions.length ) {
                            c.valueOptions = [ { value: '', label: '- Not Set -' }, ...c.valueOptions ];
                        }
                    }

                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.tasks ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.tasks.filters && user.datagrids.tasks.filters[filters.fn] && user.datagrids.tasks.filters[filters.fn].colOrder && user.datagrids.tasks.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.tasks.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.tasks.colOrder && user.datagrids.tasks.colOrder.length ) {
                            cols = user.datagrids.tasks.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady, query, rowModesModel, conPicklist, globalPicklist, oppPicklist ] );
    
    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        console.log( user.lists.accounts, user.lists.accounts.find( f => f.id === aid ) );

        if ( tasks ) {
            let list = [];
            Object.keys( tasks ).forEach( tid => {
                const t = tasks[tid];
                if ( !viewing.includes( t.aid ) ) {
                    return;
                }

                let c;
                if ( t.assoc && t.assoc.length ) {
                    c = contacts[t.assoc[0].cid];
                }

                const tmpNotes = [];
                const tmpTasks = [];
                
                if ( c ) {
                    // Object.keys( notes ).forEach( nid => {
                    //     const n = notes[nid];
                    //     const yes = n.assoc?.find( f => f.cid === c.cid );
                    //     if ( yes ) {
                    //         tmpNotes.push( n );
                    //     }
                    // } );
                    // tmpNotes.sort( ( a, b ) => {
                    //     const ad = new Date( a.createdDate );
                    //     const bd = new Date( b.createdDate );
                    //     return bd.getTime() - ad.getTime();
                    // } );

                    // const tmpTasks = Object.values( tasks ).filter( task => 
                    //     task.status === 'Completed' && task.assoc?.some( f => f.cid === c.cid )
                    // );
                    // Object.keys( tasks ).forEach( tid => {
                    //     const t = tasks[tid];
                    //     if ( t.status !== 'Completed' ) {
                    //         return;
                    //     }
                    //     const yes = t.assoc?.find( f => f.cid === c.cid );
                    //     if ( yes ) {
                    //         tmpTasks.push( t );
                    //     }
                    // } );
                    // tmpTasks.sort( ( a, b ) => {
                    //     const ad = new Date( a.completedDate ? a.completedDate : a.createdDate );
                    //     const bd = new Date( b.completedDate ? b.completedDate : b.createdDate );
                    //     return bd.getTime() - ad.getTime();
                    // } );
                }
                
                switch ( timing ) {
                    case 'now':
                        if ( !t.dueDate || !( isToday( t.dueDate ) || isInPast( t.dueDate ) ) ) {
                            return;
                        }
                        break;

                    case 'today':
                        if ( !t.dueDate || !isToday( t.dueDate ) ) {
                            return;
                        }
                        break;

                    case 'week':
                        if ( !t.dueDate || !isThisWeek( t.dueDate ) ) {
                            return;
                        }
                        break;

                    case 'nextWeek':
                        if ( !t.dueDate || !isNextWeek( t.dueDate ) ) {
                            return;
                        }
                        break;

                    case 'month':
                        if ( !t.dueDate || !isThisMonth( t.dueDate ) ) {
                            return;
                        }
                        break;

                    case 'nextMonth':
                        if ( !t.dueDate || !isNextMonth( t.dueDate ) ) {
                            return;
                        }
                        break;

                    default:
                        console.log( 'Unknown timing value: ' + timing );
                        return;
                }

                if ( !type.includes( 'all' ) && !type.includes( t.type ) ) {
                    return;
                }

                if ( !status.includes( t.status ) ) {
                    return;
                }

                if ( t.assignedTo === assignedTo ) {
                    list.push( {
                        ...c,
                        ...t,
                        assoc: t.assoc,
                        lastTask: tmpTasks[0],
                        lastNote: tmpNotes[0],
                        acctLabel: user.lists.accounts.find( f => f.id === t.aid )?.name || t.aid,
                     } );
                }
            } );
            list.sort( ( a, b ) => {
                if ( a.dueDate && b.dueDate ) {
                    const ad = new Date( a.dueDate );
                    const bd = new Date( b.dueDate );
                    return bd.getTime() - ad.getTime();
                }
                if ( a.dueDate ) {
                    return -1;
                }
                if ( b.dueDate ) {
                    return 1;
                }
                const ad = new Date( a.createdDate );
                const bd = new Date( b.createdDate );
                return bd.getTime() - ad.getTime();
            } );
            setTasks( list );
            setLoading( false );
        }
    }, [ tasks, contacts, notes, viewing, timing, type, status, assignedTo ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Tasks</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            initialState={ { 
                                                // pinnedColumns: { 
                                                //     left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ]
                                                // }
                                            } }
                                            getRowId={ ( row ) => row.tid }
                                            loading={ loading }
                                            rows={tList}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { 
                                                toolbar: toolbar,
                                                columnMenu: customColumnMenu 
                                            } }
                                            slotProps={ { toolbar: {
                                                selectedRows: selectedRows, 
                                                handleMassModal: handleMassModal, 
                                                hasTxting: hasTxting, 
                                                hasPhoneBurner: hasPhoneBurner, 
                                                canExport: canExport,
                                                timing: timing,
                                                setTiming: setTiming,
                                                type: type,
                                                setType: setType,
                                                status: status,
                                                setStatus: setStatus,
                                                assignedTo: assignedTo,
                                                setAssignedTo: setAssignedTo,
                                                team: user.lists.team,
                                                viewing: viewing,
                                            } } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            filterModel={ filterModel }
                                            onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                            getRowClassName={ getRowClassName }
                                            getRowHeight={ () => 'auto' }
                                            onColumnWidthChange={ handleColumnWidthChange }
                                            onColumnOrderChange={ handleColumnOrderChange }
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal show={show} onHide={closeModal} centered size='lg'>
                {modal}
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    tasks: state.tasks.byId,
    contacts: state.contacts.byId,
    notes: state.notes.byId,
    conPicklist: state.user.meta.contact.picklist,
    oppPicklist: state.user.meta.leadopp.picklist,
    globalPicklist: state.user.meta.global.picklist
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( Tasks );